(function () {
  function initProductFaq(section) {
    if (!section || section.dataset.wfFaqInitialized === 'true') {
      return;
    }

    section.dataset.wfFaqInitialized = 'true';

    var button = section.querySelector(
      '[data-wf-faq-request]'
    );

    if (!button) return;

    button.addEventListener('click', function () {
      var customToggle =
        document.querySelector('.wf-custom-toggle');

      if (!customToggle) return;

      customToggle.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });

      window.setTimeout(function () {
        var box = customToggle.closest(
          '.wf-custom-request-box'
        );

        if (
          box &&
          !box.classList.contains('is-open')
        ) {
          customToggle.click();
        }
      }, 450);
    });
  }

  function initAllProductFaqs() {
    document
      .querySelectorAll(
        '[data-wf-component="product-faq"]'
      )
      .forEach(function (section) {
        initProductFaq(section);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initAllProductFaqs
    );
  } else {
    initAllProductFaqs();
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      var section = event.target.querySelector(
        '[data-wf-component="product-faq"]'
      );

      if (section) {
        initProductFaq(section);
      }
    }
  );
})();